import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardPage from '../components/DashboardPage';

const PreferentialProcurement = () => {
  const navigate = useNavigate ();

const actions = [
  {
    label: 'Supplier Database',
    desc: 'Manage your qualified supplier list',
    icon: (
      <svg viewBox="0 0 24 24">
        <ellipse cx="12" cy="5" rx="9" ry="3"/>
        <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
        <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
      </svg>
    ),
  },
  {
    label: 'B-BBEE Spend',
    desc: 'Spend analysis by B-BBEE level',
    icon: (
      <svg viewBox="0 0 24 24">
        <line x1="18" y1="20" x2="18" y2="10"/>
        <line x1="12" y1="20" x2="12" y2="4"/>
        <line x1="6" y1="20" x2="6" y2="14"/>
      </svg>
    ),
  },
  {
    label: 'Preferential Procurement Scorecard',
    onClick: () => navigate('/esd/preferential-procurement/scorecard'),
    desc: 'Preferential Procurement scorecard data and compliance tracking',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
        <rect x="9" y="3" width="6" height="4" rx="1"/>
        <line x1="9" y1="12" x2="15" y2="12"/>
        <line x1="9" y1="16" x2="13" y2="16"/>
      </svg>
    ),
  },
  {
    label: 'Procurement Records',
    onClick: () => navigate('/esd/documentation/procurement/'),
    desc: 'Purchase orders and invoice records',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
      </svg>
    ),
  },
  {
    label: 'Reports',
    onClick: () => navigate('/reports/preferential-procurement'),
    desc: 'Procurement compliance reporting',
    icon: (
      <svg viewBox="0 0 24 24">
        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
        <polyline points="17 6 23 6 23 12"/>
      </svg>
    ),
  },
  {
    label: 'Submit Data',
    onClick: () => navigate('/esd/preferential-procurement/submit-datasheet'),
    desc: 'Enter and submit scorecard data',
    icon: (
      <svg viewBox="0 0 24 24">
        <line x1="22" y1="2" x2="11" y2="13"/>
        <polygon points="22 2 15 22 11 13 2 9 22 2"/>
      </svg>
    ),
  },
];
return ( 
  <DashboardPage
    theme="procurement"
    title="Preferential Procurement"
    subtitle="ESD — Preferential Procurement Element"
    actions={actions}
  />
  );
};

export default PreferentialProcurement;
